import React, { useContext } from "react";
import { ThemeContext } from "../../Context/ThemeContext";

const ThemeSelectorPage = () => {
  const { themeName, changeTheme } = useContext(ThemeContext);

  return (
    <div style={{ padding: "1rem" }}>
      <label htmlFor="theme-selector">Choose Theme: </label>
      <select
        id="theme-selector"
        value={themeName}
        onChange={(e) => changeTheme(e.target.value)}
        style={{
          padding: "0.5rem",
          borderRadius: "5px",
        }}
      >
        <option value="light">Light</option>
        <option value="dark">Dark</option>
        <option value="highContrast">High Contrast</option>
        <option value="forestRetreat">Forest Retreat</option>
        <option value="sunsetGlow">sunset Glow</option>
        <option value="oceanBreeze">Ocean Breeze</option>
        <option value="tropicalBreeze">tropicalBreeze</option>
        <option value="autumnHarvest">Autumn Harvest</option>
        <option value="lavenderDream">Lavender Dream</option>
        <option value="midnightShadow">Midnight Shadow</option>
        <option value="royalBurgundy">Royal Burgundy</option>
        <option value="forestNight">Forest Night</option>
        <option value="charcoalSlate">Charcoal Slate</option>
        <option value="obsidianGlow">Obsidian Glow</option>
      </select>
    </div>
  );
};

export default ThemeSelectorPage;
